import { render } from "./AdminHQImages.vue?vue&type=template&id=06d24ab6&scoped=true"
import script from "./AdminHQImages.vue?vue&type=script&lang=js"
export * from "./AdminHQImages.vue?vue&type=script&lang=js"

import "./AdminHQImages.vue?vue&type=style&index=0&id=06d24ab6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06d24ab6"]])

export default __exports__